import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
            平台优势
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">
            为什么选择黄桃视频？三大核心优势告诉你答案
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {featuresData.map((feat, idx) => (
              <div
                key={idx}
                className="flex flex-col items-center text-center p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200 hover:shadow-sm transition-all duration-200"
              >
                <div className="w-16 h-16 md:w-18 md:h-18 rounded-2xl bg-primary-100 flex items-center justify-center mb-5">
                  <i className={`${feat.icon} text-primary-600 text-2xl md:text-3xl`}></i>
                </div>
                <h3 className="font-heading text-lg md:text-xl text-foreground-950 mb-3">
                  {feat.title}
                </h3>
                <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
                  {feat.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}